/* eslint-disable */
<template>
  <div v-if="isMobileView && !isDevBypassed" class="mobile-blocker-overlay">
    <div class="mobile-card">
      <template v-if="'BG' === selectedLanguage">
        <p>Уеб версията на EFOCS е предназначена за десктоп екрани.</p>
        <p>За най-добро потребителско преживяване на мобилни устройства, моля, използвай нашето мобилно приложение.</p>
      </template>
      <template v-else>
        <p>The web version of EFOCS is designed for desktop screens.</p>
        <p>For the best user experience on mobile, please use our mobile app.</p>
      </template>
      <div class="store-buttons">
        <a class="store-badge" href="https://play.google.com/store/apps/details?id=app.efocs.whiz" target="_blank" rel="noopener noreferrer">
          <svg class="store-badge-icon" viewBox="0 0 512 512" aria-hidden="true">
            <path fill="#410593" d="M72.2 38.6L272.7 239 72.2 439.4c-8.9-6-14.2-16-14.2-26.8V65.4c0-10.8 5.3-20.8 14.2-26.8z" />
            <path fill="#00e4ff" d="M72.2 38.6l200.5 200.4L364 147.7 101.4 12c-10-5.7-21.7-4.2-29.2 26.6z" />
            <path fill="#ff3a44" d="M72.2 439.4l291.8-135.7-91.3-91.3L72.2 439.4z" />
            <path fill="#ffc107" d="M364 364.3l90.9-42.3c15.7-7.3 15.7-29.7 0-37L364 242.7l-91.3 91.3 91.3 30.3z" />
          </svg>
          <span class="store-badge-copy">
            <span class="store-badge-subtitle">GET IT ON</span>
            <span class="store-badge-title">Google Play</span>
          </span>
        </a>
        <a class="store-badge" href="https://apps.apple.com/us/app/efocs-stocks-bonds-etfs/id6463640515" target="_blank" rel="noopener noreferrer">
          <svg class="store-badge-icon" viewBox="0 0 170 170" fill="currentColor" aria-hidden="true">
            <path d="M150.37 130.25c-2.45 5.66-5.35 10.87-8.71 15.66-4.58 6.53-8.33 11.05-11.22 13.56-4.48 4.12-9.28 6.23-14.42 6.35-3.69 0-8.14-1.05-13.32-3.18-5.19-2.12-9.97-3.17-14.34-3.17-4.58 0-9.49 1.05-14.75 3.17-5.26 2.13-9.5 3.24-12.74 3.35-4.34.13-9.16-1.9-14.49-6.08-3.25-2.63-7.14-7.27-11.67-13.93-6.6-9.67-11.66-20.3-15.19-31.89-3.53-11.59-5.3-22.75-5.3-33.49 0-14.53 3.69-26.7 11.07-36.5 7.38-9.8 16.71-14.81 27.99-15.03 4.58 0 9.8 1.16 15.66 3.48 5.86 2.32 9.8 3.5 11.83 3.5 1.7 0 5.76-1.25 12.18-3.75 6.42-2.5 11.75-3.6 16-3.3 12.12.98 21.6 5.56 28.45 13.73-10.86 6.57-16.14 15.75-15.86 27.54.29 9.3 4.02 17.06 11.19 23.27 7.17 6.21 15.72 9.77 25.65 10.68-2.67 7.82-6.31 15.48-10.92 22.98zM119.22 31.96c0-7.05 2.58-13.88 7.74-20.48 5.16-6.6 11.79-10.49 19.89-11.68.29 1.07.43 2.06.43 2.98 0 6.94-2.65 13.78-7.95 20.52-5.3 6.74-11.89 10.64-19.78 11.7-.1-.99-.33-2.01-.33-3.04z" />
          </svg>
          <span class="store-badge-copy">
            <span class="store-badge-subtitle">DOWNLOAD ON THE</span>
            <span class="store-badge-title">App Store</span>
          </span>
        </a>
      </div>
    </div>
  </div>
  <template v-else>
    <div v-if="$store.getters.isLoginInProgress && !$store.getters.isAppReady" class="hollow-dots-spinner center">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
    <div
      v-if="$store.getters.isUserLogged && $route.name !== 'Login' && (!$store.getters.isLoginInProgress || $store.getters.isAppReady)"
      class="app-header-shell"
    >
      <AppHeader />
    </div>
    <router-view
      :class="{
        'app-view-loading': $store.getters.isLoginInProgress && !$store.getters.isAppReady
      }"
    />
  </template>
</template>

<script>
import AppHeader from "@/components/ui/Header.vue";

const DEVELOPER_BYPASS_TOKEN = "efocs_dev_982341";

function initializeDeveloperBypass() {
  try {
    const url = new URL(window.location.href);
    const previewKey = url.searchParams.get("preview_key");

    if (previewKey === DEVELOPER_BYPASS_TOKEN) {
      window.localStorage.setItem("efocs_dev_mode", "true");
      url.searchParams.delete("preview_key");
      window.history.replaceState(null, "", `${url.pathname}${url.search}${url.hash}`);
    }

    return window.localStorage.getItem("efocs_dev_mode") === "true";
  } catch (error) {
    console.error(error);
    return false;
  }
}

export default {
  components: { 
    AppHeader
  },
  data() {
    return {
      /* responsive monitoring */
      widowWidth: this.getResponsiveWindowWidth(window.innerWidth),
      isMobileView: window.innerWidth < 1200,
      isDevBypassed: initializeDeveloperBypass(),
      resizeTimeout: null,
      currentLanguage: this.$store.getters["getNonLoggedInLanguage"]?.toUpperCase() || "EN"
    }
  },
  mounted() {
    this.updateDocumentTitle();
    this.$store.commit("setAppWindowWidth", this.widowWidth);
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  watch: {
    selectedLanguage() {
      this.currentLanguage = this.selectedLanguage;
      this.updateDocumentTitle();
    }
  },
  computed: {
    selectedLanguage() {
      return this.$store.getters["getNonLoggedInLanguage"]?.toUpperCase() || "EN";
    },
    documentTitle() {
      return 0 === "BG".localeCompare(this.selectedLanguage)
        ? "EFOCS — Акции, Облигации & ETF-и"
        : "EFOCS — Stocks, Bonds & ETFs";
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
    clearTimeout(this.resizeTimeout);
  },
  methods: {
    getResponsiveWindowWidth(width) {
      return 1200 < width ? 1201 : 1199;
    },
    onResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        const responsiveWidth = this.getResponsiveWindowWidth(window.innerWidth);
        if (responsiveWidth === this.widowWidth) {
          return;
        }

        this.widowWidth = responsiveWidth;
        this.isMobileView = window.innerWidth < 1200;
        this.$store.commit("setAppWindowWidth", responsiveWidth);
      }, 150);
    },
    updateDocumentTitle() {
      document.title = this.documentTitle;
    }    
  }
};
</script>

<style scoped>

.mobile-blocker-overlay {
  align-items: center;
  background-color: #ffffff;
  color: #0f172a;
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  padding: 1.5rem;
  position: fixed;
  text-align: center;
  top: 0;
  width: 100vw;
  z-index: 999999;
}

.mobile-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  box-shadow: 0 0.625rem 1.5625rem -0.3125rem rgba(0, 0, 0, 0.08);
  max-width: 23.75rem;
  padding: 2.25rem 1.75rem;
  width: 100%;
}

.mobile-card p {
  color: #475569;
  font-size: 0.9375rem;
  line-height: 1.6;
  margin-bottom: 1.75rem;
}

.store-buttons {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.store-badge {
  align-items: center;
  background-color: #000000;
  border-radius: 0.5rem;
  box-shadow: 0 0.125rem 0.3125rem rgba(0, 0, 0, 0.1);
  color: #ffffff;
  display: flex;
  gap: 0.75rem;
  height: 3.25rem;
  justify-content: center;
  max-width: 15rem;
  text-decoration: none;
  transition: background-color 0.15s ease, transform 0.15s ease;
  width: 100%;
}

.store-badge:hover {
  background-color: #1a1a1a;
  color: #ffffff;
  transform: translateY(-1px);
}

.store-badge-icon {
  flex-shrink: 0;
  height: 1.5rem;
  width: auto;
}

.store-badge-copy {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
  text-align: left;
}

.store-badge-subtitle {
  color: #d1d5db;
  font-size: 0.5625rem;
  font-weight: 500;
  letter-spacing: 0.03125rem;
  text-transform: uppercase;
}

.store-badge-title {
  color: #ffffff;
  font-size: 1rem;
  font-weight: 600;
  margin-top: 0.125rem;
}

.logo-container {
  display: flex;
  align-items: flex-end;
}

#ef-logo {
  max-height: 2rem;
  width: auto;
}

#whiz-logo {
  max-height: 2rem;
  width: auto;
}

#logo {
  position: fixed;
  bottom: 0.5rem;
  right: 2rem;
  height: 1rem;
  max-height: 1rem;
}

#powered-by {
  position: fixed;
  bottom: 0.5rem;
  left: 2rem;
  height: 1rem;
  max-height: 1rem;
}

#product_of {
  text-align: right;
  font-size: 1rem;
  margin-bottom: 0.15rem;
}

.span_wrap {
  white-space: nowrap;
  word-wrap: hyphenate;
}

.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: auto;
}

.header {
  position: fixed;
  top: 0;
  width: 100%;
  height: 1rem;
  min-height: 1rem;
  max-height: 1rem;
  padding: 0.75rem 0.5rem;
}

.center {
  position: fixed;
  /* or absolute */
  top: calc(50% - 7px);
  left: calc(50% - 45px);
}
.app-view-loading {
  opacity: 0;
  pointer-events: none;
}
.hollow-dots-spinner,
.hollow-dots-spinner * {
  box-sizing: border-box;
}

.hollow-dots-spinner {
  height: 15px;
  width: calc(30px * 3);
}

.hollow-dots-spinner .dot {
  width: 15px;
  height: 15px;
  margin: 0 calc(15px / 2);
  border: calc(15px / 5) solid #0088AA;
  border-radius: 50%;
  float: left;
  transform: scale(0);
  animation: hollow-dots-spinner-animation 1000ms ease infinite 0ms;
}

.hollow-dots-spinner .dot:nth-child(1) {
  animation-delay: calc(300ms * 1);
}

.hollow-dots-spinner .dot:nth-child(2) {
  animation-delay: calc(300ms * 2);
}

.hollow-dots-spinner .dot:nth-child(3) {
  animation-delay: calc(300ms * 3);

}

.st0 {
  fill: #ED1C24;
}

@keyframes hollow-dots-spinner-animation {
  50% {
    transform: scale(1);
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
</style>
